/* eslint-disable */
export default class View {
    constructor(controller, container, config) {
        if (container && controller) {
            this.controller = controller;
            this.container = container;
        }
        else {
            throw new Error('Missing required args');
        }

        this.config = config || {};
    }

    render(callback) {
        if (callback) {
            callback();
        }
    }

    renderData(key, callback) {
        if (callback) {
            callback(key);
        }
    }

    emit(message, data) {
        this.controller.notify(message, data);
    }
}
